const mimeForIntroUrl = (url: string): string => {
  const path = url.split('?')[0].toLowerCase();
  if (path.endsWith('.m3u8')) {
    return 'application/x-mpegurl';
  }
  return 'video/mp4';
};

export const getIntroVideoUrl = (stored: string | null | undefined): string => (stored ?? '').trim();

export const isRemoteIntroVideoPlaceholder = (file: File): boolean => {
  const n = file.name?.trim() ?? '';
  return n.startsWith('http://') || n.startsWith('https://');
};

export const createIntroVideoFormFile = (urlFromApi: string): File => {
  const url = getIntroVideoUrl(urlFromApi);
  return new File([], url, { type: mimeForIntroUrl(url) });
};
